import tw from "tailwind-styled-components";

export default tw.section`
    flex
    flex-col
    text-center
    justify-center
    sm:justify-between
    gap-6
    sm:gap-12
    sm:flex-row
    text-headline
    font-bold
    text-purple-base
    py-2
`